<div class="container" *ngIf="!hasWritePermission()">
    {{localizationKeys.aumico_reports_write_permission_error | i18next}}
</div>
<div class="container" *ngIf="hasWritePermission()">
    {{localizationKeys.aumico_reports_placeholder_needs_implementation | i18next}}
</div>
